exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".motivator-icon{justify-content:center;display:flex}.motivator-icon .motivator-icon-container{border-radius:50%;height:35px;width:35px;display:flex;align-items:center;justify-content:center}.motivator-icon .motivator-icon-container img{height:20px}", ""]);

// exports
